import BuyingFilter from "../../components/filteration/buyingFilter";
import ShopAdds from "../../components/shopAds/ShopAdds";
import Shops from "../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import BackArrow from "../../components/backArrow";
import url from "../../config/axios";
import { ShopContext } from "../../config/shopContext";
import { GEM_SHOP_ALLOWED_CONNECT_TYPES } from "../../constants/businessTypeConnectionRules";
import "./MultipleShops.css";

const MultipleShops = ({
  allowedConnectBusinessTypes = GEM_SHOP_ALLOWED_CONNECT_TYPES,
} = {}) => {
  const shopType = "gemShop"; // unique identifier for this page
  const { name } = useSelector((state) => state.user);
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [isloading, setIsloading] = useState(false);
  const [createshopcategory, setCreateshopcategory] = useState();
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  const [filters, setFilters] = useState(currentData.additionalData || {
    shopname: "", shopCategory: "", marketPlace: "", shopid: "",
    specialoffer: "", sale: "", itemname: "", categoryid: "",
    subCategoryid: "", country: "", state: "", city: "",
    salespromotion: "", min: "", max: ""
  });

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  // Split only on the first "." so category names that contain dots stay intact.
  const parseIdName = (value = "") => {
    const idx = String(value).indexOf(".");
    if (idx === -1) return [value];
    return [value.slice(0, idx), value.slice(idx + 1)];
  };

  const Handledata = (e) => {
    const { name, value } = e.target;
    const parsed = parseIdName(value);

    setDataCategory((prev) => {
      if (name === "categoryid") {
        return { ...prev, categoryid: parsed };
      }
      return { ...prev, [name]: parsed };
    });

    // Category change invalidates subcategory so options stay in sync.
    if (name === "categoryid") {
      setFilters((prev) => ({
        ...prev,
        categoryid: parsed[0] || "",
        subCategoryid: "",
      }));
      setShopCategorytwo([]);
    }
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters((prev) => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  // fetch main categories
  useEffect(() => {
    url.get("category/type/?type=gemShop&parentCategory=")
      .then(res => res?.data?.success && setCreateshopcategory(res.data.data.Category))
      .catch(() => {});
  }, []);

  // fetch subcategories
  useEffect(() => {
    url.get("category/type/?type=gemShop&parentCategory=true")
      .then(res => res?.data?.success && setShopCategory(res.data.data.Category))
      .catch(() => {});
  }, []);

  const Mydata = () => {
    if (!categoryName) {
      setShopCategorytwo([]);
      return;
    }
    url
      .get("category/type/", {
        params: {
          type: "gemShopItem",
          parentCategory: categoryName,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          setShopCategorytwo(res.data.data.Category);
        } else {
          setShopCategorytwo([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setShopCategorytwo([]);
      });
  };

  // Prefetch sub-categories when category changes (not only on dropdown click).
  useEffect(() => {
    if (!categoryName) {
      setShopCategorytwo([]);
      return;
    }
    Mydata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryName]);

  const Handleadditioanalshop = (e) => {
    const { name, value } = e.target;
    // categoryid is managed by Handledata / sync effect as the raw id only
    if (name === "categoryid") return;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const buildQuery = (type) => {
    let query = { businessType: shopType, filtermethod: type };
    const keys = type === "shop"
      ? ["shopname","shopCategory","marketPlace","shopid","specialoffer","sale"]
      : ["itemname","categoryid","subCategoryid","country","state","city","specialoffer","salespromotion","min","max"];
    keys.forEach(k => { if(filters[k] && filters[k].trim() !== "") query[k] = filters[k].trim(); });
    return new URLSearchParams(query).toString();
  };

  const FilterHandler = () => {
    setIsloading(true);
    const newFilters = { ...filters, itemname:"", categoryid:"", subCategoryid:"", country:"", state:"", city:"", salespromotion:"", min:"", max:"" };
    setFilters(newFilters);

    const query = buildQuery("shop");
    url.get(`/shop/filter?${query}`)
      .then(res => {
        setIsloading(false);
        if(res?.data?.success){
          setShopdata(res.data.Shop || []);
          setItemmdata(res.data.ShopItem || []);
          updateFilteredData(shopType, res.data.Shop || [], res.data.ShopItem || [], newFilters);
        }
      }).catch(() => setIsloading(false));
  };

  const FilterHandleritem = () => {
    setIsloading(true);
    const newFilters = { ...filters, shopname:"", shopCategory:"", marketPlace:"", shopid:"", specialoffer:"", sale:"" };
    setFilters(newFilters);

    const query = buildQuery("shopitem");
    url.get(`/shop/filter?${query}`)
      .then(res => {
        setIsloading(false);
        if(res?.data?.success){
          setShopdata(res.data.Shop || []);
          setItemmdata(res.data.ShopItem || []);
          updateFilteredData(shopType, res.data.Shop || [], res.data.ShopItem || [], newFilters);
        }
      }).catch(() => setIsloading(false));
  };  


  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel showmodal={showmodal} handleClosemodal={handleClosemodal} handleShowshare={handleShowshare} />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="multiple-shops-mobile-back d-lg-none" />
        <Row className="multiple-shops-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                FilterHandleritem={FilterHandleritem}
                Handleadditioanalshop={Handleadditioanalshop}
                FilterHandler={FilterHandler}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="ps-2 pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/Minerl-And-Mining-UserProfile"
                title="Minerals & Mining"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
                allowedConnectBusinessTypes={allowedConnectBusinessTypes}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MultipleShops;
